<script setup lang="ts">
import { onMounted } from "vue"
import { useAuthStore } from "./stores/auth"
import AppShell from "./components/AppShell.vue"

const auth = useAuthStore()
onMounted(() => auth.hydrate())
</script>

<template>
  <AppShell>
    <RouterView />
  </AppShell>
</template>
